// O WhatsApp manda a menção de grupo como `@<digitos>` — telefone ou LID — e
// quem troca pelo nome é o aparelho de quem lê. Aqui a tela faz o mesmo, com
// a lista de `GET /tickets/:id/participantes`.

// O que aparece depois do `@`: o nome, senão o telefone, senão o código.
export const rotuloDoParticipante = (p) =>
  p.nome || (p.numero ? `+${p.numero}` : p.id.split("@")[0]);

export const mapaDeMencoes = (participantes = []) => {
  const mapa = new Map();

  participantes.forEach((p) => {
    const rotulo = rotuloDoParticipante(p);

    if (p.numero) mapa.set(p.numero, rotulo);
    if (p.lid) mapa.set(p.lid.split("@")[0], rotulo);
  });

  return mapa;
};

export const trocarMencoes = (texto, mapa) =>
  !texto || !mapa?.size
    ? texto
    : texto.replace(/@(\d{5,20})\b/g, (todo, digitos) =>
        mapa.has(digitos) ? `@${mapa.get(digitos)}` : todo,
      );

// O caminho de volta, no envio: `@Nome` digitado ou escolhido vira o
// `@<digitos>` que o WhatsApp exige, e o jid entra em `mencoes`. Rótulo mais
// longo primeiro, senão "@Ana" comeria o começo de "@Ana Paula".
export const prepararMencoes = (texto, participantes = []) => {
  const mencoes = [];
  let saida = texto;

  [...participantes]
    .map((p) => ({ p, rotulo: rotuloDoParticipante(p) }))
    .sort((a, b) => b.rotulo.length - a.rotulo.length)
    .forEach(({ p, rotulo }) => {
      const marca = `@${rotulo}`;
      let achou = false;

      saida = saida
        .split(marca)
        .reduce((acc, pedaco, i) => {
          if (i === 0) return pedaco;
          // "@Ana" seguido de letra é outra palavra ("@Anabela"), não ela.
          if (/^[\p{L}\p{N}_]/u.test(pedaco)) return `${acc}${marca}${pedaco}`;
          achou = true;
          return `${acc}@${p.id.split("@")[0]}${pedaco}`;
        }, "");

      if (achou) mencoes.push(p.id);
    });

  return { texto: saida, mencoes };
};
